import React from 'react';

// Squelette de chargement (index.css §12, owner 2026-09-10 — piste 5).
// `Sk` = un bloc gris à reflet ; `TableSkeleton` = la carte de liste du site
// (entête .th-ki, N lignes de 81 px, pied de pagination) à la forme exacte du
// tableau attendu, pour que la page garde sa hauteur pendant le chargement.
export const Sk = ({ w = '100%', h = 12, className = '', style }) => (
  <span className={`sk ${className}`} style={{ width: w, height: h, ...style }} aria-hidden="true" />
);

// columns : [{ label, avatar, w, h, align }] — `avatar` = pastille 48 px +
// ligne (colonne « nom »), `w`/`h` = taille de la ligne grise, `align: 'right'`
// pour les colonnes chiffrées.
export const TableSkeleton = ({ rows = 10, columns, footer = true, label = 'Chargement de la liste' }) => (
  <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" role="status" aria-live="polite" aria-label={label}>
    <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead>
          <tr>
            {columns.map((c, i) => (
              <th key={i} className={`th-ki px-5 py-3 text-xs uppercase ${c.align === 'right' ? 'text-right' : 'text-left'}`}>
                {c.label || <span className="sr-only">—</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r} className="border-t border-gray-100">
              {columns.map((c, i) => (
                <td key={i} className="td-ki px-5 py-4">
                  {c.avatar ? (
                    <div className="flex items-center gap-3">
                      <Sk className="sk-av" w={48} h={48} />
                      <Sk w={c.w || '45%'} h={c.h || 12} />
                    </div>
                  ) : c.w ? (
                    <div className={c.align === 'right' ? 'flex justify-end' : ''}>
                      <Sk w={c.w} h={c.h || 12} />
                    </div>
                  ) : null}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {footer && (
      <div className="flex items-center px-5 py-4 border-t border-gray-100 bg-white gap-3">
        <Sk w={150} h={12} className="flex-none" />
        <div className="flex-1" />
        <Sk w={36} h={36} style={{ borderRadius: 8 }} />
        <Sk w={36} h={36} style={{ borderRadius: 8 }} />
        <Sk w={36} h={36} style={{ borderRadius: 8 }} />
      </div>
    )}
  </div>
);

// Fiche / panneau / formulaire : un titre puis des lignes de largeur décroissante,
// pleine largeur du conteneur (w-full) pour tenir dans les blocs centrés.
export const CardSkeleton = ({ lines = 6, title = true, className = '' }) => {
  const widths = ['100%', '85%', '92%', '70%', '88%', '60%', '95%', '75%'];
  return (
    <div className={`w-full space-y-3 ${className}`} role="status" aria-live="polite" aria-label="Chargement">
      {title && <Sk w="38%" h={16} />}
      {Array.from({ length: lines }).map((_, i) => <Sk key={i} w={widths[i % widths.length]} h={12} />)}
    </div>
  );
};

// Dans un bouton : le libellé devient une barre à reflet blanc (kit §12), le
// bouton garde sa hauteur ; le texte qui suit reste pour les lecteurs d'écran.
export const BtnSk = ({ w = 64, h = 10 }) => (
  <Sk w={w} h={h} className="sk-w sk-inline" style={{ borderRadius: h / 2 }} />
);

export default TableSkeleton;
